import Axios from "axios";
import config from "../config";
import { store } from "./../store/store";
import { logout } from "./pages/auth/authAction";

const axios = Axios.create({
  baseURL: config.apiHost.replace("[subdomain].", ""),
});

// Those is already handled within authMiddlewares.js
axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      console.info("Axios received 401");
      store.dispatch(logout());
    }
    return err;
  }
);

export default axios;
